<template>
  <div
    class="bg-maintenance-overlay"
    role="alertdialog"
    aria-modal="true"
    :aria-label="$t('maintenance.title')"
  >
    <div class="bg-maintenance">
      <div class="bg-maintenance__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="42" height="42">
          <path
            d="M12 3l9.5 16.5H2.5L12 3z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linejoin="round"
          />
          <path d="M12 9v5M12 16.5h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>
      <h1 class="bg-maintenance__title">{{ $t('maintenance.title') }}</h1>
      <p class="bg-maintenance__message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlackGoldMaintenanceOverlay',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
